<template>
  <div>
    <el-dialog title="查看客户" :visible="visible" width="1200px" :before-close="handleClose">
      <div>
        <el-table :data="buyeData" v-loading="loading" 
          :header-row-style="{backgroundColor:'red'}"
          tooltip-effect="light"
          class="table-box"
          ref="buyerData"
        >
          <el-table-column prop="pin" label="买家昵称"></el-table-column>
          <el-table-column prop="fullName" label="买家姓名">
            <template slot-scope="scope">
                <div class="show-box" v-if="!scope.row.fullNameState">
                  <span>{{scope.row.fullName}}</span>
                  <!-- <div
                    class="hover-show"
                    @click="showInfo(1, scope.row, scope.$index)"
                    style="width:110px"
                    :style="{'background': globalBG}"
                  >显示买家姓名</div> -->
                </div>
                <div v-else>{{scope.row.fullName}}</div>
              </template>
          </el-table-column>
          <el-table-column prop="grade" label="会员等级"></el-table-column>
          <el-table-column prop="mobile" label="手机号码">
            <template slot-scope="scope">
                <div class="show-box" v-if="!scope.row.fullMobileState">
                  <span>{{scope.row.mobile || '--'}}</span>
                  <!-- <div
                    class="hover-show"
                    @click="showInfo(3, scope.row, scope.$index)"
                    style="width:110px"
                    :style="{'background': globalBG}"
                  >显示手机号码</div> -->
                </div>
                <div v-else>{{scope.row.mobile || '--'}}</div>
              </template>
          </el-table-column>
          <el-table-column prop="buyTotalMoney" sortable label="交易总额"></el-table-column>
          <el-table-column prop="buyTotalCount" sortable label="购买次数"></el-table-column>
          <el-table-column prop="dormancyDays" sortable label="未购买天数"></el-table-column>
          <el-table-column prop="avgPrice " sortable label="平均客单价"></el-table-column>
          <el-table-column prop="buyerLastTime" width="130px" sortable label="最后交易时间"></el-table-column>
        </el-table>
        <div style="text-align:right; margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChangs"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50 , 100 ,500]"
            :page-size="paramX.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :current-page="paramX.current"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getShopBuyer, shopDetail} from "@/api/shopBuyer.js"
import { mapState, mapMutations } from "vuex";

export default {
  name: 'viewBuyerDialog',
  props: {
    param: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: true,
      buyeData: [],
      loading: false,
      paramX: {
        size: 1,
        current: 10
      },
      total: 0,
    }
  },
   computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },

  mounted() {
    this.paramX = this.param;
    this.getDataList();
  },

  methods: {
     showInfo(type, row, index) {
      var param = {
        pin: row.pin,
        detatilType: type,
      };
      shopDetail(param).then((res) => {
        if (res.code == "1") {
          if (type == "1") {
            // 买家姓名
            this.buyeData[index].fullName = res.data.fullName;
            this.buyeData[index].fullNameState = true;
          } else if (type == "3") {
            // 手机号码
            this.buyeData[index].mobile = res.data.mobile;
            this.buyeData[index].fullMobileState = true;
          }
        }
      });
    },

    getDataList() {
        this.loading = true;
        getShopBuyer(this.paramX).then(res => {
          this.loading = false;
          if (res.code == '1') {
            this.buyeData = res.data.records;
            this.total = +res.data.total;
            // this.showViewBuyerDialog = true;
          }
        })
    },
    handleSizeChangs(val) {
      this.paramX.size = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.paramX.current = val;
      this.getDataList();
    },

    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-table .el-table__header-wrapper th .cell {
    height: 60px;
    line-height: 50px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    -webkit-font-smoothing: antialiased;
    color: #333333;
}
.show-box {
  position: relative;
  .hover-show {
    display: none;
    position: absolute;
    left: 0%;
    top: 50%;
    text-align: center;
    transform: translate(0, -50%);
    color: #fff;
    cursor: pointer;
    padding: 1px 10px;
    border-radius: 4px;
  }
  &:hover {
    .hover-show {
      display: inline-block;
    }
  }
}

.table-box{
  max-height: 400px;
  overflow: auto;
}
</style>